import { render } from "./readEventClub.vue?vue&type=template&id=a74ad662&scoped=true"
import script from "./readEventClub.vue?vue&type=script&lang=js"
export * from "./readEventClub.vue?vue&type=script&lang=js"

import "./readEventClub.vue?vue&type=style&index=0&id=a74ad662&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a74ad662"]])

export default __exports__